<template>
  <div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="ts-flex ts-space-x-3 ts-items-end">
            <div>
              <label>{{ $t('tracking.dateRange') }}</label>
              <a-date-picker
                v-model="model.date"
                :allowClear="false"
                format="DD-MM-YYYY HH:mm:ss"
                valueFormat="DD-MM-YYYY HH:mm:ss"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </div>
            <div class="ts-w-full">
              <label>{{ $t('tracking.district') }}</label>
              <a-select
                :maxTagCount="5"
                mode="multiple"
                class="ts-w-full"
                v-model="model.district_code"
                :options="distrctCode"
                showSearch
                :filterOption="filterOption"
                :placeholder="$t('tracking.district')"
                @search="handleSearchDistrict"
              ></a-select>
            </div>
            <ts-button
              color="primary"
              @click.prevent="fetchData"
              class="ts-h-8"
              >{{ $t('view') }}</ts-button
            >
          </div>
        </ts-card-wrapper>
        <div class="row">
          <div class="col-md-10">
            <gmap-map
              ref="gmap"
              :center="center"
              :zoom="zoom"
              style="width:100%;  height: calc(100vh - 103px)"
            >
              <gmap-polyline
                v-if="!loading"
                :path="plPath"
                :options="{ geodesic: true, strokeColor: '#FF0000' }"
              >
              </gmap-polyline>

              <gmap-marker
                v-for="(s, index) in saleMarker"
                :key="index"
                title="Start"
                :position="{
                  lat: s.lat,
                  lng: s.long
                }"
                :icon="{
                  url: findIcon(s.employee_name_en),
                  scaledSize: { width: 35, height: 35 },
                  labelOrigin: {
                    x: 30,
                    y: -2
                  }
                }"
                :label="{
                  text:
                    index +
                    1 +
                    '-' +
                    s.employee_name_kh +
                    ' ' +
                    s.employee_name_en,
                  color: '#ec3b76',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }"
                @click="e => onMarkerClick(e, s)"
              />

              <gmap-info-window
                :options="{
                  maxWidth: 400,
                  pixelOffset: { width: 0, height: -35 }
                }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @closeclick="infoWindow.open = false"
              >
                <div v-html="infoWindow.template"></div>
              </gmap-info-window>
            </gmap-map>
          </div>
          <div class="col-md-2">
            <div class="ts-pr-4 ts-h-full">
              <div class="ts-border ts-p-1 ts-rounded-md ts-h-full">
                <div v-if="sales.length">
                  <ul>
                    <li
                      v-for="(sale, index) in sales"
                      :key="index"
                      class="ts-p-2 ts-cursor-pointer hover:ts-bg-gray-200 ts-rounded ts-whitespace-no-wrap ts-overflow-hidden ts-transition-all ts-duration-300"
                      @click="onClickShowMap(sale)"
                    >
                      <span>{{ index + 1 }}</span> {{ sale.employee_name_en }}
                    </li>
                  </ul>
                </div>
                <div
                  v-else
                  class="ts-h-full ts-flex ts-items-center ts-justify-center"
                >
                  <div class="ts-w-full ts-text-center">
                    <p class="ts-m-0">
                      <i class="fas fa-folder-open fa-3x ts-text-gray-300"></i>
                    </p>
                    <h2 class="ts-text-gray-300 ts-text-base ts-m-0">
                      {{ $t('tracking.noData') }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapActions } from 'vuex'
import peopleBlue from '@/assets/marker/people-blue.svg'
import peopleYellow from '@/assets/marker/people-yellow.svg'
import calDistance from './calDistance'

export default {
  name: 'nearestSale',
  data() {
    return {
      loading: false,
      distrctCode: undefined,
      peopleBlue,
      peopleYellow,
      plPath: [],
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      zoom: 13,
      saleMarker: [],
      sales: [],
      selectedSale: '',
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: ''
      },
      model: {
        date: moment().format('DD-MM-YYYY HH:mm:ss'),
        district_code: undefined
      }
    }
  },
  created() {
    this.handleSearchDistrict()
  },
  methods: {
    moment,
    ...mapActions('sale/locationTracking', ['getDistrict', 'fetchNearest']),
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    clearMap() {
      this.plPath = []
      this.saleMarker = []
      this.sales = []
      this.selectedSale = ''
    },
    fetchData() {
      this.loading = true
      this.clearMap()
      this.fetchNearest(this.model)
        .then(response => {
          this.sales = response.data
        })
        .finally(() => (this.loading = false))
    },
    handleSearchDistrict: debounce(function(search) {
      this.loading = true
      this.getDistrict({
        filter: {
          search
        }
      })
        .then(result => {
          this.distrctCode = result.data.map(item => ({
            value: item.district_code,
            label: item.name_kh + ' ' + item.p_name_kh
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }, 500),
    onClickShowMap(row) {
      if (row.group_sale_intersec.length) {
        this.selectedSale = row.employee_name_en
        this.$refs.gmap.$mapPromise.then(map => {
          map.panTo({
            lat: row.group_sale_intersec[0].lat,
            lng: row.group_sale_intersec[0].long
          })
          this.zoom = 18
        })
        this.saleMarker = row.group_sale_intersec

        this.saleMarker[0].distance = calDistance(
          this.saleMarker[2].lat,
          this.saleMarker[2].long,
          this.saleMarker[0].lat,
          this.saleMarker[0].long
        )

        this.saleMarker[1].distance = calDistance(
          this.saleMarker[0].lat,
          this.saleMarker[0].long,
          this.saleMarker[1].lat,
          this.saleMarker[1].long
        )

        this.saleMarker[2].distance = calDistance(
          this.saleMarker[1].lat,
          this.saleMarker[1].long,
          this.saleMarker[2].lat,
          this.saleMarker[2].long
        )

        this.plPath = this.saleMarker.map(el => ({
          lat: el.lat,
          lng: el.long
        }))

        this.plPath.push({
          lat: row.group_sale_intersec[0].lat,
          lng: row.group_sale_intersec[0].long
        })
      }
    },
    onMarkerClick(event, sale) {
      const {
        lat,
        long,
        employee_name_kh,
        employee_name_en,
        phone,
        tracking_time,
        distance
      } = sale
      this.infoWindow.position = { lat: lat, lng: long }
      this.infoWindow.template = `<b>${new Date(
        tracking_time
      ).toLocaleString()}</b><br/><b>${employee_name_kh} ${employee_name_en}</b><br>${phone} <br/><br/> <b>${distance.toFixed(
        2
      )} Meter<b/>`
      this.infoWindow.open = true
    },
    findIcon(name) {
      return this.selectedSale.toLowerCase() === name.toLowerCase()
        ? this.peopleBlue
        : this.peopleYellow
    }
  }
}
</script>
